<template>
  <v-container class="ma-0 pa-0">
        <v-select :label="props.label" v-model="direction"  :items="pointsFilteredByResolution"
            item-title="text" item-value="value" hide-details :clearable="isClearable"></v-select>
    
        <div id="sq_container"> 
        <div id="sq_container_center">

          <v-btn  
            v-for="point in pointsFilteredByResolution" :key="point.value"
            variant="flat"  icon dark :color="direction === point.value ? 'primary' : 'white'" x-small @click="pointClicked(point.value)"
            :style="btnStyle(point)"
            
            >{{ point.value }}</v-btn>
            <div id="pointer" :style="rotationStyle" v-if="direction !== null"></div>
        </div>
        </div>
  </v-container>
</template>

<script setup>

import { ref, computed, onMounted, inject } from "vue";
 
const direction = defineModel()

const props = defineProps(["label","resolution", "clearable"])
const isFormReadOnly = ref(false) 


const points = ref([
  {
    text: "Nord",
    value: "N",
    rotation: 0,
    resolutions: [45, 22.5],
  },
  {
    text: "Nord-Nord-Est",
    value: "NNE",
    rotation: 22.5,
    resolutions: [22.5],
  },
  {
    text: "Nord-Est",
    value: "NE",
    rotation: 45,
    resolutions: [45, 22.5],
  },
  {
    text: "Est-Nord-Est",
    value: "ENE",
    rotation: 67.5,
    resolutions: [22.5],
  },
  {
    text: "Est",
    value: "E",
    rotation: 90,
    resolutions: [45, 22.5],
  },

  {
    text: "Est-Sud-Est",
    value: "ESE",
    rotation: 112.5,
    resolutions: [22.5],
  },
  {
    text: "Sud-Est",
    value: "SE",
    rotation: 135,
    resolutions: [45, 22.5],
  },

  {
    text: "Sud-Sud-Est",
    value: "SSE",
    rotation: 157.5,
    resolutions: [22.5],
  },
  {
    text: "Sud",
    value: "S",
    rotation: 180,
    resolutions: [45, 22.5],
  },
  {
    text: "Sud-Sud-Ovest",
    value: "SSO",
    rotation: 202.5,
    resolutions: [22.5],
  },
  {
    text: "Sud-Ovest",
    value: "SO",
    rotation: 225,
    resolutions: [45, 22.5],
  },
  {
    text: "Ovest-Sud-Ovest",
    value: "OSO",
    rotation: 247.5,
    resolutions: [22.5],
  },
  {
    text: "Ovest",
    value: "O",
    rotation: 270,
    resolutions: [45, 22.5],
  },
  {
    text: "Ovest-Nord-Ovest",
    value: "ONO",
    rotation: 292.5,
    resolutions: [22.5],
  },
  {
    text: "Nord-Ovest",
    value: "NO",
    rotation: 315,
    resolutions: [45, 22.5],
  },

  {
    text: "Nord-Nord-Ovest",
    value: "NNO",
    rotation: 337.5,
    resolutions: [22.5],
  },
])

const isClearable = computed(() => {

  if (isFormReadOnly.value) {
    return false
  }
  return props?.clearable
})


if (props?.clearable) {
  points.value.push(
  {
    text: "Non rilevato",
    value: null,
    rotation: 0,
    resolutions: [45, 22.5],
  },

  )
}

const pointsFilteredByResolution = computed (() => {
  return points.value.filter((elem) => {
    return elem.resolutions.includes( props.resolution);
  })
})

const  pointClicked = (newValue) => {

  if (isFormReadOnly.value) {
    return }

  direction.value = newValue;
}




const btnStyle = (point) => {
  // return `transform: ${translationFromAngle(angle)}`
  // const x_percent = Math.cos((angle-90) * Math.PI / 180) * 200;
  // const y_percent = Math.sin((angle-90) * Math.PI / 180) * 200;
  // // return `translate(${x_percent}%,${y_percent}%)`;
  // return `translate(0,0)`;
  let top_percent = 0;
  let left_percent = 0;

  if (point?.value) { 
    top_percent = Math.sin((point.rotation - 90) * Math.PI / 180) * 40;
    left_percent = Math.cos((point.rotation - 90) * Math.PI / 180) * 40;
  }
  return `left: ${left_percent}% ; top: ${top_percent}% ;`;
  
}


const rotationStyle = computed(() => {
  let r = 0;
  const rotationStyle = {};
  // console.dir(direction.value)
  if (direction.value) {
    r = points.value.filter((elem) => {
      return elem.value === direction.value;
    })[0].rotation;
  }
  // console.dir(r)
  rotationStyle.transform = `rotate(${r}deg) translate(4px, 4px)`;
  return rotationStyle;
})


onMounted(() => {


  const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
    isFormReadOnly.value = svf.isReadonly.value

  // $nextTick(() => {
  //   direction.value = value;
  // });

  if ( !direction?.value) {
    direction.value = null
  }
})
</script>

<style scoped>

#sq_container .v-btn{
  border: 2px solid gray;
}
#sq_container {
  max-width: 30em;
  margin: 1em auto;
  width: 100%;
  display: flex;
  aspect-ratio : 1 / 1;
  position: relative;
  background: center center url('@/assets/img/rosa_venti.jpg');
  background-size: cover;

  /* filter: grayscale(80%); */

}
#sq_container_center {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  /* background-color: rgba(255,0,0,.3); */
}


#sq_container div:hover {
  /* background: rgba(50,50,50,.03); */
  cursor: pointer;
}

#sq_container .v-btn {
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  z-index: 10;
}


#sq_container #circle {
  background: none;
  position: absolute;
  border: 5px solid red;
  z-index: 0;
  border-radius: 49%;
  aspect-ratio: 1;
  width: 90%;
  height: 90%;
  margin: 5%;
  /* background-color: lightgray; */
}

#sq_container #pointer {
  border-right: 8px solid #1867c0;
  width: 50%;
  height: 50%;
  position: absolute;
  left: -50%;
  top: -50%;
  transform-origin: 100% 100%;
  transition: 250ms ease-in-out all;
}
</style>
